import { ORDER_STATUS } from '@src/constants/order';
import { EVENT_ORDERS_LIMIT } from '@src/constants/topPaidEvent';
import api from './api';
import { getOrders } from './orders';

const getEventPaidOrders = ({ startTime, endTime }) =>
  getOrders({
    status: ORDER_STATUS.PAID,
    startDate: new Date(startTime).toISOString(),
    endDate: new Date(endTime).toISOString(),
    fields: 'actualPrice,createdAt',
    limit: EVENT_ORDERS_LIMIT,
  });

// All of the signed-in user's codes for the event, oldest first, in one page.
const getRewardCodes = async (eventId) => {
  const response = await api({
    method: 'GET',
    url: `/events/${encodeURIComponent(eventId)}/reward-codes`,
  });
  return response;
};

export { getEventPaidOrders, getRewardCodes };
